// src/components/NavBar.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import './NavBar.css';

export default function NavBar() {
  const { user, signInWithGoogle, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <Link to="/" className="navbar-brand">
            <span className="brand-icon">🎳</span>
            <span className="brand-text">Sunday League</span>
          </Link>
        </div>

        <div className="navbar-links">
          {/* This must match the path in App.js */}
          <Link to="/submit">Score</Link>
          <Link to="/leaderboard">Leaderboard</Link>
          <Link to="/team">Team</Link>
          <Link to="/stats">My Stats</Link>
        </div>

        <div className="navbar-right">
          {user ? (
            <div className="user-menu">
              <Link to="/profile" className="profile-link">
                {user.photoURL ? (
                  <img src={user.photoURL} alt="Profile" className="nav-avatar" />
                ) : (
                  <div className="avatar-placeholder">{user.displayName?.charAt(0)}</div>
                )}
              </Link>
              <button onClick={() => { logout(); navigate('/'); }} className="logout-btn">
                Logout
              </button>
            </div>
          ) : (
            <button onClick={signInWithGoogle} className="login-btn">
              Google Login
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}